import { IUserAccountStore } from '../index'
import { ISetSliderTab } from '../../../actions/userAccount/limit/setSliderTab'

export default function(
  store: IUserAccountStore,
  action: ISetSliderTab,
): IUserAccountStore {
  return {
    ...store,
    sliderTab: action.tab,
  }
}
